import React from 'react';

import cl from './PricingNotice.module.css'

const PricingNotice = () => {
    return (
        <div className={cl.background_page}>
            <div className={cl.main_pricing_wrapper}>
                <h1 className={cl.pricing_title}>
                    Pricing notice for Business Clients
                </h1>
                <div className={cl.pricing_notice_container}>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>LuxPay offers four pricing options for business clients,
                            which vary depending on the company’s business sector, risk profile, and country of
                            registration.
                        </li>
                        <li className={cl.pricing_list_item}>The applicable pricing option is determined by LuxPay only
                            after the application review and risk assessment process is completed.
                        </li>
                        <li className={cl.pricing_list_item}>Please note that for high-risk clients, 50% of the account
                            opening fee is charged in advance and is non-refundable if onboarding is not completed or is
                            unsuccessful.
                        </li>
                    </ul>
                    <h2 className={cl.pricing_title_block}>I. Small Business / Standard Risk</h2>
                    <span className={cl.pricing_pre_title_block}>Office-based Businesses:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Dentist’s office;</li>
                        <li className={cl.pricing_list_item}>Plumbers, electricians;</li>
                        <li className={cl.pricing_list_item}>Engineering and architecture firms;</li>
                        <li className={cl.pricing_list_item}>Data processing and hosting services;</li>
                        <li className={cl.pricing_list_item}>IT support, cybersecurity, network administration
                            services;
                        </li>
                    </ul>

                    <span className={cl.pricing_pre_title_block}>Retail & Commerce:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Retail shops, pet supplies, online apparel stores, parking
                            garages;
                        </li>
                        <li className={cl.pricing_list_item}>Bookstores and stationery shops;</li>
                        <li className={cl.pricing_list_item}>Electronics retail (non-cash intensive);</li>
                        <li className={cl.pricing_list_item}>Home goods and furniture stores;</li>
                        <li className={cl.pricing_list_item}>Sporting goods retailers;</li>
                        <li className={cl.pricing_list_item}>Office supply stores;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Food Services:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Coffee shops and cafes;</li>
                        <li className={cl.pricing_list_item}>Bars, restaurants;</li>
                        <li className={cl.pricing_list_item}>Fast food and quick-service restaurants;</li>
                        <li className={cl.pricing_list_item}>Catering services;</li>
                        <li className={cl.pricing_list_item}>Bakeries;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Education & Healthcare:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Tutoring and training centers;</li>
                        <li className={cl.pricing_list_item}>Daycare centers;</li>
                        <li className={cl.pricing_list_item}>Small dental and medical clinics;</li>
                        <li className={cl.pricing_list_item}>Educational support services;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Other:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Auto repair and maintenance shops;</li>
                        <li className={cl.pricing_list_item}>Laundromats;</li>
                        <li className={cl.pricing_list_item}>Photography studios;</li>
                        <li className={cl.pricing_list_item}>Pet grooming services;</li>
                        <li className={cl.pricing_list_item}>Landscaping;</li>
                        <li className={cl.pricing_list_item}>Agriculture;</li>
                    </ul>
                    <h2 className={cl.pricing_title_block}>II. Medium Business / Elevated Risk</h2>
                    <span className={cl.pricing_pre_title_block}>Professional Services:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Legal or notary practice;</li>
                        <li className={cl.pricing_list_item}>Administrative management, business development
                            consulting;
                        </li>
                        <li className={cl.pricing_list_item}>IT consulting and software development;</li>
                        <li className={cl.pricing_list_item}>Accounting, tax consulting services, Audit services;</li>
                        <li className={cl.pricing_list_item}>Online Advertising and Marketing;</li>
                        <li className={cl.pricing_list_item}>Other consulting services;</li>
                        <li className={cl.pricing_list_item}>Intermediary services;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>E-commerce & Digital:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Online marketplaces;</li>
                        <li className={cl.pricing_list_item}>Subscription-based services;</li>
                        <li className={cl.pricing_list_item}>Digital product sales;</li>
                        <li className={cl.pricing_list_item}>Electronic shopping platforms;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Construction & Contracting:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>General contractors;</li>
                        <li className={cl.pricing_list_item}>Specialty trade contractors;</li>
                        <li className={cl.pricing_list_item}>Project-based construction firms;</li>
                        <li className={cl.pricing_list_item}>Renovation companies;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Transportation & Logistics:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Independent trucking companies;</li>
                        <li className={cl.pricing_list_item}>Courier services;</li>
                        <li className={cl.pricing_list_item}>Moving companies;</li>
                        <li className={cl.pricing_list_item}>Logistics coordination;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Real Estate:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Miniware houses and self-storage facilities;</li>
                        <li className={cl.pricing_list_item}>Property management firms;</li>
                        <li className={cl.pricing_list_item}>Real estate development;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Wholesale & Distribution:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Wholesale businesses handling standard product
                            categories;
                        </li>
                        <li className={cl.pricing_list_item}>Regional distributors;</li>
                        <li className={cl.pricing_list_item}>Supply chain intermediaries;</li>
                        <li className={cl.pricing_list_item}>B2B equipment suppliers;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Hospitality:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Hotels and motels;</li>
                        <li className={cl.pricing_list_item}>Event planning services;</li>
                        <li className={cl.pricing_list_item}>Tourism operators;</li>
                        <li className={cl.pricing_list_item}>Travel booking agencies;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Manufacturing:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Small to mid-size manufacturers;</li>
                        <li className={cl.pricing_list_item}>Contract manufacturers;</li>
                        <li className={cl.pricing_list_item}>Light assembly operations;</li>
                        <li className={cl.pricing_list_item}>Consumer goods production;</li>
                    </ul>
                    <h2 className={cl.pricing_title_block}>III. Medium-High Business / High Operational Complexity</h2>
                    <span className={cl.pricing_pre_title_block}>Pharmaceutical & Biotech:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Pharmaceutical manufacturing companies;</li>
                        <li className={cl.pricing_list_item}>Biotech firms;</li>
                        <li className={cl.pricing_list_item}>Medical device manufacturers;</li>
                        <li className={cl.pricing_list_item}>Clinical research organizations (CROs);</li>
                        <li className={cl.pricing_list_item}>Pharmaceutical distribution networks;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>International Trade:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Import/export businesses with complex supply chains;</li>
                        <li className={cl.pricing_list_item}>Customs brokers;</li>
                        <li className={cl.pricing_list_item}>International freight forwarders;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Healthcare (Complex):</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Nursing homes, assisted living facilities;</li>
                        <li className={cl.pricing_list_item}>Large healthcare clinics;</li>
                        <li className={cl.pricing_list_item}>Hospital systems;</li>
                        <li className={cl.pricing_list_item}>Multi-specialty medical groups;</li>
                        <li className={cl.pricing_list_item}>Pharmaceutical wholesalers;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Luxury & High-Value Goods:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Fine art dealers;</li>
                        <li className={cl.pricing_list_item}>Luxury automobile dealerships;</li>
                        <li className={cl.pricing_list_item}>High-end jewelry businesses;</li>
                        <li className={cl.pricing_list_item}>Precious metals and gemstone traders;</li>
                        <li className={cl.pricing_list_item}>Antique dealers;</li>
                    </ul>
                    <h2 className={cl.pricing_title_block}>IV. High-Risk Sector</h2>
                    <span className={cl.pricing_pre_title_block}>Gaming & Gambling:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Casinos and gaming facilities;</li>
                        <li className={cl.pricing_list_item}>Online gambling platforms;</li>
                        <li className={cl.pricing_list_item}>Sports betting operations;</li>
                        <li className={cl.pricing_list_item}>Lottery services;</li>
                        <li className={cl.pricing_list_item}>Gaming software providers;</li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Money or Value Transfer Services (MVTS):</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Money transmission services;</li>
                        <li className={cl.pricing_list_item}>Currency exchanges;</li>
                        <li className={cl.pricing_list_item}>Remittance services;</li>
                        <li className={cl.pricing_list_item}>Prepaid instruments or prepaid card programs;</li>
                        <li className={cl.pricing_list_item}>POS solutions, payment hardware, and alternative payment
                            systems;
                        </li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Cryptocurrency & Digital Assets:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Cryptocurrency exchanges;</li>
                        <li className={cl.pricing_list_item}>Digital wallet providers;</li>
                        <li className={cl.pricing_list_item}>Blockchain companies;</li>
                        <li className={cl.pricing_list_item}>ICO/Token offerings;</li>
                        <li className={cl.pricing_list_item}>Crypto mining operations;</li>
                        <li className={cl.pricing_list_item}>Any type of crypto-related activities, businesses, or
                            transaction
                        </li>
                    </ul>
                    <span className={cl.pricing_pre_title_block}>Regulated Financial Services:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Banks, Payment and Electronic money institutions;</li>
                        <li className={cl.pricing_list_item}>Investment firms, investment advisory;</li>
                        <li className={cl.pricing_list_item}>Private banking services</li>
                        <li className={cl.pricing_list_item}>Funds / asset managers;</li>
                        <li className={cl.pricing_list_item}>Lending and credit services (consumer, business, mortgage,
                            asset-backed);
                        </li>
                        <li className={cl.pricing_list_item}>Insurance (life, investment-linked);</li>
                        <li className={cl.pricing_list_item}>Crowdfunding platforms;</li>
                    </ul>
                    <span
                        className={cl.pricing_pre_title_block}>Financial-related / fiduciary / structuring services:</span>
                    <ul className={cl.pricint_list}>
                        <li className={cl.pricing_list_item}>Trust companies;</li>
                        <li className={cl.pricing_list_item}>Nominee services;</li>
                        <li className={cl.pricing_list_item}>Offshore company structures;</li>
                        <li className={cl.pricing_list_item}>Corporate service providers;</li>
                        <li className={cl.pricing_list_item}>Multi-jurisdictional holding companies;</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PricingNotice;